import React from 'react';

import { UnsavedChangesWarningModal } from '../../common';
import { useUnsavedChangesPrompt } from '../../../hooks/useUnsavedChangesPrompt';
import { usePricingBatchStaging } from './PricingBatchStagingContext';

const PRICING_BATCHES_UNSAVED_BODY =
    'You have queued price change actions that are not submitted yet, or an open Approve, Decline, or interim price panel. Leaving this page will lose that work. Are you sure you want to leave?';

export function PricingBatchesUnsavedChangesGuard({
    children,
}: Readonly<React.PropsWithChildren>) {
    const { queuedCount, hasOpenQuickActionExpansion } =
        usePricingBatchStaging();
    const isDirty = queuedCount > 0 || hasOpenQuickActionExpansion;
    const blocker = useUnsavedChangesPrompt(isDirty);

    return (
        <>
            {children}
            <UnsavedChangesWarningModal
                opened={blocker.state === 'blocked'}
                onStay={() => blocker.reset?.()}
                onLeave={() => blocker.proceed?.()}
                bodyText={PRICING_BATCHES_UNSAVED_BODY}
            />
        </>
    );
}
